// extracted by css-extract-rspack-plugin
export default {"modalBody":"_f807d2ac","mediumPadding":"_83ef1afb","noPadding":"_26cdc227","small":"_901b6ae8","medium":"_2090caca","large":"_7d12a98a"};